<template>
    <div class="form-box mb10" v-loading="loading">
        <el-form inline :model="formData" size="mini" ref="formInline" @submit.native.prevent="handleOnSubmit">

            <el-form-item prop="id">
                <CustomInput label='ID' @append-click="handleGenAppendClick('id', '输入或粘贴ID，每行一个')">
                    <ESelect v-model="formData.id" filterable clearable placeholder="请输入" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="id"
                        @visible-change="(val) => handleVisibleChange(val, 'id')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'id')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="() => handleSelectAll(id_DataList, 'id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="() => handleSelectAll(id_DataList, 'id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in id_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="plat_id">
                <CustomInput label='媒体'>
                    <el-select v-model="formData.plat_id"  placeholder="请选择" @change="handlePlatIdChange">
                        <el-option v-for="item in plat_list" :key="item.id" :label="item.name"
                            :value="item.id" />
                    </el-select>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_md5">
                <CustomInput label='玩咖素材MD5' @append-click="handleGenAppendClick('material_md5', '输入或粘贴玩咖素材MD5，每行一个')">
                    <ESelect v-model="formData.material_md5" filterable clearable placeholder="请输入玩咖素材MD5搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="material_md5"
                        style="width: 220px"
                        @visible-change="(val) => handleVisibleChange(val, 'material_md5')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'material_md5')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="() => handleSelectAll(material_md5_DataList, 'material_md5', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="() => handleSelectAll(material_md5_DataList, 'material_md5', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in material_md5_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="plat_md5">
                <CustomInput label='媒体素材MD5' @append-click="handleGenAppendClick('plat_md5', '输入或粘贴媒体素材MD5，每行一个')">
                    <ESelect v-model="formData.plat_md5" filterable clearable placeholder="请输入媒体素材MD5搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="plat_md5"
                         style="width: 220px"
                        @visible-change="(val) => handleVisibleChange(val, 'plat_md5')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'plat_md5')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="() => handleSelectAll(plat_md5_DataList, 'plat_md5', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="() => handleSelectAll(plat_md5_DataList, 'plat_md5', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in plat_md5_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="account_id">
                <CustomInput label='账户ID' @append-click="handleGenAppendClick('account_id', '输入或粘贴账户ID，每行一个')">
                    <ESelect v-model="formData.account_id" filterable clearable placeholder="请输入账户ID搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="account_id"
                        @visible-change="(val) => handleVisibleChange(val, 'account_id')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'account_id')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="() => handleSelectAll(account_id_DataList, 'account_id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="() => handleSelectAll(account_id_DataList, 'account_id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in account_id_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="ad_id">
                <CustomInput label='广告ID' @append-click="handleGenAppendClick('ad_id', '输入或粘贴广告ID，每行一个')">
                    <ESelect v-model="formData.ad_id" filterable clearable placeholder="请输入广告ID搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="ad_id"
                        @visible-change="(val) => handleVisibleChange(val, 'ad_id')"
                        :remote-method="(search) => appEntrySearchList(search, 'ad_id')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="() => handleSelectAll(ad_id_DataList, 'ad_id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="() => handleSelectAll(ad_id_DataList, 'ad_id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in ad_id_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                </CustomInput>
            </el-form-item>

            

            <el-form-item>
                <CustomInput label='创建人'>
                    <template #prepend>
                        <el-select
                            style="width:70px"
                            v-model="select_user_type"
                            slot="prepend"
                            placeholder="请选择"
                            class="customInput_prepend_select"
                            @change="handleUserTypeChange"
                        >
                            <el-option value="1" label="创建人"></el-option>
                            <el-option value="2" label="编辑人"></el-option>
                        </el-select>
                    </template>
                    <template style="width: 160px;">
                        <SelectAll :options="create_user_DataList" :placeholder="'请选择创建人'" v-model="formData.create_user" v-if="select_user_type == 1"/>
                        <SelectAll :options="edit_user_DataList" :placeholder="'请选择编辑人'" v-model="formData.edit_user" v-else/>
                    </template>
                    
                </CustomInput>
            </el-form-item>

            <el-form-item>
                <CustomInput label='创建时间'>
                    <template #prepend>
                        <el-select
                            style="width:80px"
                            v-model="select_time_type"
                            slot="prepend"
                            placeholder="请选择"
                            class="customInput_prepend_select"
                            @change="handleTimeTypeChange"
                        >
                            <el-option value="1" label="创建时间"></el-option>
                            <el-option value="2" label="编辑时间"></el-option>
                        </el-select>
                    </template>
                    <template style="width: 160px;">
                        <el-date-picker v-model="formData.range_time" type="daterange" range-separator="至"
                            start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                            end-placeholder="结束日期" :picker-options="basePickerOptions"  v-if="select_time_type == 1">
                        </el-date-picker>
                        <el-date-picker v-model="formData.edit_time" type="daterange" range-separator="至"
                            start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                            end-placeholder="结束日期" :picker-options="basePickerOptions"  v-else>
                        </el-date-picker>
                    </template>
                    
                </CustomInput>
            </el-form-item>

            <el-form-item prop="status">
                <CustomInput label='对比结果'>
                    <el-select
                        style="width:140px"
                        v-model="formData.status"
                        placeholder="请选择"
                        multiple
                        collapse-tags
                    >
                        <el-option 
                            :value="item.value" 
                            :label="item.label" 
                            v-for="(item, index) in status_DataList" 
                            :key="index"
                        />
                    </el-select>
                </CustomInput>
            </el-form-item>

        </el-form>
        <div class="opts">
            <el-button type="primary" size="mini" @click="handleOnSubmit" :loading="searchPropLoading">查询</el-button>
            <el-button size="mini" @click="resetForm('formInline')">清空筛选</el-button>
        </div>
    </div>
</template>

<script>

import CustomInput from '@/components/CustomInput'
import SelectAll from '@/components/SelectAll';
import CascaderAll from '@/views/workOrder/components/cascaderAll';
import { uniqBy, debounce } from 'lodash'
import { batchSelectModal } from "@/components/modal"
import { compareGetSearchListApi } from '@/api/systemTool/compare'
export default {
    name: 'comparePage_query',
    components: {
        CustomInput,
        SelectAll,
        CascaderAll
    },
    props: {
        query: {
            type: Object,
            default: ()=>{}
        },
        searchPropLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            basePickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker) {
                            const date = new Date();
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                            let endDate = new Date(date.getTime());
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            // 上周：自然周，周一到周日
                            let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * (weekDay === 0 ? 6 : weekDay - 1));
                            let endDate = new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * 6);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-' + month + '-1';
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            let startDate = new Date(year + '-' + month + '-01');
                            let endDate = new Date(new Date(year + '-' + (month + 1) + '-01').getTime() - 1000 * 60 * 60 * 24);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = year + '-01-01';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-04-01';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-07-01';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-10-01';
                            }
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;

                            let startDate = '';
                            let endDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = (year - 1) + '-10-01';
                                endDate = (year - 1) + '-12-31';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-01-01';
                                endDate = year + '-03-31';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-04-01';
                                endDate = year + '-06-30';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-07-01';
                                endDate = year + '-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                ]
            },
            plat_list:[],
            dictData: {},
            status_DataList: [],
            id_DataList: [],
            plat_md5_DataList: [],
            material_md5_DataList: [],
            account_id_DataList: [],
            ad_id_DataList: [],
            create_user_DataList: [],
            edit_user_DataList: [],
            formData: {
                plat_id: '',  //媒体
                id: [],
                material_md5:[],
                plat_md5: [],
                account_id: [],  //账户ID
                ad_id: [],   //广告ID
                create_user: [],  //创建人
                range_time: [], //创建时间
                edit_user: [],
                edit_time: [],
                status: [],    //对比结果
            },
            select_user_type: '1',
            select_time_type: '1',
            customFilter: [], // ['plat_id', 'delivery_scene', 'delivery_type', 'material_type', 'material_w_h', 'label_ids', 'is_used'],
            searchLoading: false,
            loading: false,
            game_classify_disabled: false,

            
        }
    },
    watch: {
        'formData.plat_id'(val) {
           this.formData.create_user = []
           this.formData.edit_user = []
        }
    },
    mounted() {
        compareGetSearchListApi({search_type: 'plat'}).then(res=>{
            this.plat_list = res.data.list;
            const [ firstPlat = {} ] = res.data.list || [];
            this.formData.plat_id = firstPlat.id;
            // if(this.plat_list && this.plat_list.length > 0) {
            //     this.formData.plat_id = this.plat_list[0]['id']
            // }
        }).finally(()=>{
            this.fetchGetSearchOther(true)
        })

        const { md5, material_type, project, is_used, material_w_h_DataList } = this.$route.query

        this.$nextTick(() => {
            if (md5) {
                let md5_array = md5.split(',')
                this.material_md5_DataList = md5_array.map(item => {
                    return {
                        value: item,
                        label: item
                    }
                })
                this.formData.material_md5 = md5_array
            }
            if (material_type && project && is_used && material_w_h_DataList) {
                this.formData.material_type = material_type.split(',').map(item => Number(item))
                this.formData.is_used = is_used.split(',').map(item => Number(item))


                let toJsonListProject = JSON.parse(decodeURIComponent(project))
                let toJsonListWh = JSON.parse(decodeURIComponent(material_w_h_DataList))

                // 项目名称赋值
                this.formData.project_id = toJsonListProject.map(item => item.value)
                this.project_id_DataList = toJsonListProject

                // 素材尺寸赋值
                this.formData.material_w_h = toJsonListWh.map(item => item.id)
                this.material_w_h_DataList = uniqBy([...toJsonListWh, ...this.material_w_h_DataList], 'id')
            }

            // this.handleOnSubmit()
        })

    },
    methods: {
        handlePlatIdChange() {
            this.fetchGetSearchOther(false)
        },
        // fetchGetCustomFilter() {
        //     this.loading = true
        //     APICOMMON.getCustomFilter({ field_type: 'work_order_material_filter' }).then(res => {
        //         this.loading = false
        //         if (res.data && res.data.length > 0) {
        //             this.customFilter = res.data
        //         }
        //         this.fetchGetSearchOther()
        //     }, err => {
        //         this.loading = false
        //         this.$message.error(err.info)
        //     }).finally(() => {
        //         // this.handleOnSubmit()
        //     })
        // },

        //部分 远程搜索下拉枚举值
        fetchGetSearchOther(isGetList) {
            let forArray = ['status','create_user', 'edit_user']
            return Promise.all(forArray.map((item) => {
                return compareGetSearchListApi({ plat_id: this.formData.plat_id, search: '', batch_search: '', search_type: item }).then(res => {
                    this[`${item}_DataList`] = res.data.list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                    if(item === 'status' && isGetList) {
                        if( this.status_DataList && this.status_DataList.length > 0) {
                            this.formData.status = ['0']
                        }
                    }

                }, err => {
                    this.$message.error(err.info)
                })
            })).finally(()=> {
                isGetList&&this.handleOnSubmit()
            })
            
        },
        handleUserTypeChange(val) {
            if(val == '1') {
                this.formData.edit_user = [];
                compareGetSearchListApi({ plat_id: this.formData.plat_id, search: '', batch_search: '', search_type: 'create_user' }).then(res => {
                    this[`create_user_DataList`] = res.data.list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }, err => {
                    this.$message.error(err.info)
                })
            }else{
                this.formData.create_user = [];
                compareGetSearchListApi({ plat_id: this.formData.plat_id, search: '', batch_search: '', search_type: 'edit_user' }).then(res => {
                    this[`edit_user_DataList`] = res.data.list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }, err => {
                    this.$message.error(err.info)
                })
            }
        },
        handleTimeTypeChange(val) {
            if(val == '1') {
                this.formData.edit_time = []
            }else{
                this.formData.range_time = []
            }
        },
        handleStatusChange(val) {
            // 未处理判断
            if (!val.includes('0')) {
                this.$message.warning('未处理不允许删除');
                return;
            }
            this.formData.status = val
        },

        // 下拉检索
        throttleAppEntrySearchList: debounce(function (search, type, p = {}, cb) {
            this.appEntrySearchList(search, type, p, cb)
        }, 200),
        async appEntrySearchList(search, type, p = {}, cb) {
            try {
                const params = {
                    search_type: type,
                    search,
                    plat_id: this.formData.plat_id,
                    ...p
                };
                this.searchLoading = true
                const { data } = await compareGetSearchListApi(params);
                const list = data.list;
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, () => {
                        const ids = list.map(v => v.id)
                        this[`${type}_DataList`] = [
                            ...this[`${type}_DataList`].filter(v => this.formData[type].includes(v.value) && !ids.includes(v.value)),
                            ...list.map(v => {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData[type] = [...new Set([...this.formData[type], ...ids])];
                    })
                } else {
                    this[`${type}_DataList`] = list.map(v => {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },

        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback) => {
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                    },
                    (errs, cb) => {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: () => {
                                    cb();
                                    vm.close();
                                }
                            })
                        } else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected || [];
                const listData = options.map(v => {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if (selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v => v.value));
                // 去重 赋值
                this.formData[type] = [...new Set(data)]
            } else {
                let optionList_ids = this[`${type}_DataList`].map(item => item.value)
                let channel_ids = this.formData[type].filter(item => !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
        handleOnSubmit() {
            let params = {}
            for (let key in this.formData) {
                params[key] = this.formData[key]
            }
            let res_upload_time = this.formData.range_time ? this.formData.range_time.join('/') : ''; //时间的格式处理
            let res_edit_time = this.formData.edit_time ? this.formData.edit_time.join('/') : '';
            params['range_time'] = res_upload_time
            params['edit_time'] = res_edit_time

            if (Object.keys(this.$route.query).length != 0) {
                // this.$router.push({name:'material', query:{}})
            }
            this.$emit('query-click', params)
        },
        //清空
        resetForm() {
            this.formData.id =[]
            this.formData.material_md5 =[]
            this.formData.plat_md5 = []
            this.formData.account_id = []  //账户ID
            this.formData.ad_id = []   //广告ID
            this.formData.create_user = []  //创建人
            this.formData.range_time = [] //创建时间
            this.formData.edit_user = []
            this.formData.edit_time = []
            this.formData.status = ['0']
            
        },
    }
}
</script>
<style lang="scss" scoped>
.opts {
    border-top: 1px solid #DCDFE6;
    padding-top: 10px;
}

.form-box {
    background: #ffffff;
    border-radius: 4px;
    padding: 20px 10px;

    &::v-deep {
        .el-form-item {
            margin-bottom: 10px;
        }
    }
}

.table-context {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    padding-top: 12px;
}

.storeFlex {
    display: inline-flex;
    width: 220px;
    align-items: center;
    overflow: hidden;
}
</style>
